import * as React from "react";
import { useEffect } from "react";

export function useSessionState(key: string, defaultValue: any, clear?: boolean, useOnce?: boolean) {
    if (clear) {
        sessionStorage.removeItem(key);
    }
    const [state, setState] = React.useState(
        () => JSON.parse(sessionStorage.getItem(key)) || defaultValue
    );
    useEffect(() => {
        sessionStorage.setItem(key, JSON.stringify(state));
    }, [key, state]);

    useEffect(() => {
        if (useOnce) {
            sessionStorage.removeItem(key);
        }
    }, []);

    return [state, setState];
}
